import { render, staticRenderFns } from "./AuditRequest.vue?vue&type=template&id=4856475a&scoped=true&"
import script from "./AuditRequest.vue?vue&type=script&lang=js&"
export * from "./AuditRequest.vue?vue&type=script&lang=js&"
import style0 from "./AuditRequest.vue?vue&type=style&index=0&id=4856475a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856475a",
  null
  
)

export default component.exports